import React from "react";
import { Link } from "react-router-dom";
import { Briefcase, FileUp, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import Seo from "@/components/Seo";
import PublicLayout from "@/components/layout/PublicLayout";
import PageHeader from "@/components/PageHeader";

const PATH = ["Industry", "Skill", "Location", "Job", "Application", "Interview", "Career"];

export default function ForJobSeekers() {
  return (
    <PublicLayout waMessage="Hi Dreamzz HR & Consultancy, I am looking for job opportunities.">
      <Seo title="For Job Seekers — Find Jobs" description="Discover genuine jobs across Karnataka. Register, submit your resume and get matched with the right opportunity by Dreamzz HR & Consultancy." />
      <PageHeader eyebrow="For Job Seekers" title="Looking For A Job?" subtitle="Register, submit your resume, and let our recruiters match you with the right opportunity across Karnataka." />
      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <h2 className="font-display text-2xl font-bold flex items-center gap-2"><Briefcase className="text-brand-emerald" />Your Career Path</h2>
        <div className="mt-6 flex flex-wrap items-center gap-3">
          {PATH.map((p, i) => (
            <React.Fragment key={p}>
              <span className="glass rounded-full px-5 py-2.5 font-medium">{p}</span>
              {i < PATH.length - 1 && <ArrowRight size={16} className="text-brand-emerald" />}
            </React.Fragment>
          ))}
        </div>
        <div className="mt-12 grid sm:grid-cols-2 gap-5">
          <div className="glass card-hover rounded-2xl p-8">
            <Briefcase size={30} className="text-brand-emerald" />
            <h3 className="font-display text-xl font-bold mt-3">Explore Jobs</h3>
            <p className="text-slate-400 mt-2">Browse the latest openings across Karnataka and apply in minutes.</p>
            <Link to="/jobs"><Button className="mt-5 bg-brand-emerald hover:bg-[#C62828] text-white font-semibold">Explore Jobs <ArrowRight size={16} className="ml-2" /></Button></Link>
          </div>
          <div className="glass card-hover rounded-2xl p-8">
            <FileUp size={30} className="text-brand-blue" />
            <h3 className="font-display text-xl font-bold mt-3">Submit Your Resume</h3>
            <p className="text-slate-400 mt-2">Add your profile to our database and get matched with relevant roles.</p>
            <Link to="/submit-resume"><Button variant="outline" className="mt-5 border-white/15">Submit Resume</Button></Link>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
